import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import { eventQBus } from "../../types/EventQBus";

export default class LoadNavBottomLinks {
  static onLoadNavBottomLinks(data: DresonRuleResolvedEvent): void {
    const navBottomLinksNode: HTMLElement | null =
      document.getElementById("reptile-nav-bottom-links") || document.getElementById("san_navBottomLinks");
    if (!navBottomLinksNode) {
      return;
    }

    const { rule } = navBottomLinksNode.dataset;
    if (rule === data.rule) {
      return;
    }

    fetch(LoadNavBottomLinks.uri(data.rule))
      .then(LoadNavBottomLinks.extractResponseText)
      .then((html: string) => LoadNavBottomLinks.replaceNavBottomLinks(navBottomLinksNode, data.rule, html))
      .then(LoadNavBottomLinks.emitNavBottomLinksLoaded)
      .catch((e: Error) => {
        console.warn(`Filter reload AJAX GET against ${LoadNavBottomLinks.uri(data.rule)} failed: ${e.message}`);
      });
  }

  private static extractResponseText(xhr: Response) {
    if (xhr.status !== 200 && xhr.status !== 204) {
      throw Error(`Failed to retrieve nav bottom links: ${xhr.status} ${xhr.statusText}`);
    }
    return xhr.text();
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  private static replaceNavBottomLinks(navBottomLinksNode: HTMLElement, rule: string, html: string) {
    /*                                 */
    const range = document.createRange();
    range.selectNodeContents(navBottomLinksNode);

    /*                                                               */
    const fragment = range.createContextualFragment(html);

    /*           */
    range.deleteContents();
    range.insertNode(fragment);

    /*                     */
    navBottomLinksNode.dataset.rule = rule;

    /*                                                                     */
    window.preload_polyfill_invoke(navBottomLinksNode);
  }

  private static uri(ruleString: string) {
    return `/nav-imberator/bottom-links/?selektion=${ruleString}`;
  }

  private static emitNavBottomLinksLoaded() {
    eventQBus.emit("ftfind.navBottomLinks.loaded");
  }
}
